import { useRef } from 'react'
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitType from 'split-type'
import classNames from 'classnames'
import { useBreakpoint } from '../../hooks/useBreakpoint'


import styles from './AnimQueueText.module.scss'
import ImageComponent from '../Image/Image'
import { useOnload } from '../../hooks/useOnload'

gsap.registerPlugin(ScrollTrigger)

export const AnimQueueText = (props) => {
  const breakpoint = useBreakpoint()
  const animTextParentRef = useRef(null)
  const animBlockRef = useRef(null)
  const animTextRef = useRef(null)
  const splitTypeRef = useRef(null)
  const animImagesRef = useRef(null)
  const onload = useOnload()

  useGSAP(() => {
    const tl = gsap.timeline({
      paused: true,
    })

    splitTypeRef.current = SplitType.create(animTextRef.current, {types: 'words', tagName: 'span'})

    tl.from(splitTypeRef.current?.words, {
      stagger: breakpoint === 'desktop' ? .1 : .2,
      opacity: .3,
      clearProps: 'transform,opacity',
      scrollTrigger: {
        trigger: animBlockRef.current,
        start: breakpoint === 'desktop' ? 'center center' : 'top center',
        end: breakpoint === 'desktop' ? 'bottom+=200% center' : 'bottom center',
        scrub: 1,
        // markers: true,
        pin: breakpoint === 'desktop' ? true : false,
        anticipatePin: 1,
        fastScrollEnd: 3000,
        refreshPriority: 2,
      }
    }, '')

    if (breakpoint === 'desktop') {
      gsap.fromTo(animImagesRef.current, {
        yPercent: 100,
      }, {
        yPercent: -100,
        duration: 1,
        ease: 'none',
        clearProps: 'transform',
        scrollTrigger: {
          trigger: animBlockRef.current,
          start: 'top center',
          end: 'bottom+=200% center',
          // markers: true,
          scrub: 1,
          fastScrollEnd: 3000,
          onToggle(self) {
            animImagesRef.current.style.display = self.isActive ? 'flex' : 'none'
          },
        }
      }, '')
    }

    return () => {
      tl.kill()
    }
  }, [breakpoint, onload], animTextParentRef)

  return (
    <div
      className={classNames(styles['anim-queue'])}
      ref={animTextParentRef}
    >
      {breakpoint === 'mobile' && props.mobileImage &&
        <div className={classNames(styles['anim-queue__image-mobile'])}>
          <ImageComponent src={props.mobileImage} width="343" height="224" alt="" />
        </div>
      }
      <div className={classNames(styles['anim-queue__inner'])}>
        <div className={classNames(styles['anim-queue__text'])} ref={animBlockRef}>
          <div className={classNames(styles['anim-queue__text-inner'])}>
            { props.title && (
              <h2 className={classNames(styles['anim-queue__text-title'])}>{props.title}</h2>
            ) }
            <p
              className={classNames(styles['anim-queue__text-paragraph'])}
              dangerouslySetInnerHTML={{ __html: props.text}}
              ref={animTextRef}
            />
          </div>
        </div>
        {breakpoint === 'desktop' && props.images &&
          <div className={classNames(styles['anim-queue__images'])} ref={animImagesRef}>
            {props.images.map((item, index) => (
              <div
                key={index}
                className={classNames(styles['anim-queue__images-item'])}
                style={{
                  '--margin-left': item.margin[0],
                  '--margin-bottom': item.margin[1]
                }}
              >
                <ImageComponent src={item.src} width="440" height="280" alt="" />
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  )
}
